/* ===========================================================================
 Listing
 =========================================================================== */

import {activeClass} from "../settings/settings";

if ($('.js-favorite-item').length > 0) {
    $('.js-favorite-item').each(function(key) {
        var itemId = $(this).attr('item');
        var url = '/favorite-article/'+itemId;
        var that = this;
        $(this).bind('click',  function(el) {
            var url = '/favorite-article/'+el.currentTarget.getAttribute('item');
            $.ajax({
                xhrFields: {
                    withCredentials: true
                },
                dataType: 'json',
                method : 'post',
                url,
            })
            .error((request, status, error) => {
                if (request.status == 401) {
                    window.location.href = '/connexion?_target_path=' + window.location.pathname ;
                }
            })
            .done((response) => {
                $(that).html(response.favoritedItemCount);
                if (response.isFavorited == true) {
                    $(that).addClass(activeClass + ' icon-heart-fill');
                } else {
                    $(that).removeClass(activeClass + ' icon-heart-fill');
                }
            });
        });
    });
}
